import { Box } from '@mui/material';
import { useMemo } from 'react';

import { useContactTab } from '~/scenes/PeopleModule/components/Tabs/ContactTab/useContactTab';

import { EmergencyContact } from './components/EmergencyContact/component';
import { HomeContact } from './components/HomeContact/component';
import { OtherContact } from './components/OtherContact/component';
import { WorkContact } from './components/WorkContact/component';
import { useSxStyles } from './useStyles';

export const ContactTab = () => {
  const sxStyles = useSxStyles();

  const { workContact, homeContact, emergencyContact, otherContact } =
    useContactTab();

  const sections = useMemo(() => {
    return [
      {
        enabled: workContact.canView,
        content: <WorkContact {...workContact} />,
      },
      {
        enabled: homeContact.canView,
        content: <HomeContact {...homeContact} />,
      },
      {
        enabled: emergencyContact.canView,
        content: <EmergencyContact {...emergencyContact} />,
      },
      {
        enabled: otherContact.canView,
        content: <OtherContact {...otherContact} />,
      },
    ].filter((section) => section.enabled);
  }, [workContact, homeContact, emergencyContact, otherContact]);

  return (
    <Box sx={sxStyles.root}>
      {sections.map((section, index) => {
        return (
          <Box sx={sxStyles.section} key={`contact-section-${index}`}>
            {section.content}
          </Box>
        );
      })}
    </Box>
  );
};
